import axios from 'axios'

const state = {
  items: [],
  load: true,
  dataUploaded: false,
  error: false,
  errorText: '',
};
const mutations = {
  add(state, item) {
    state.items.push(item);
  },
  err(state, text) {
    state.error = true;
    state.errorText = text;
    state.load = false;
    state.dataUploaded = false;
  }
};
const actions = {
  get_list(context) {
    if (context.state.dataUploaded) return;
    context.state.load = true;
    context.state.dataUploaded = true;
    axios({
      method: 'post',
      url: '/tourclient/masterAgent/dictionary/paymentOperation/list',
      data: {
        request: JSON.stringify({}),
      }
    }).then(r => {
      if (r.data.ResultQueryInfo.HasError) {
        context.dispatch('error', {status: r.status, text: r.data.ResultQueryInfo.UserMessages}, {root: true});
        return;
      }
      context.state.items = [];
      r.data.Items.forEach(item => {
        item.value = item.Id || item.ID;
        item.label = item.Name;
        context.commit('add', item);
      });
      context.state.load = false;
    }).catch(e => {
      context.dispatch('error', e, {root: true});
    });
  },
  get_listWithItem(context, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/tourclient/masterAgent/dictionary/paymentOperation/list',
        data: {
          request: JSON.stringify({SelectedId: payload}),
        }
      }).then(r => {
        if (r.data.ResultQueryInfo.HasError) {
          context.dispatch('error', {status: r.status, text: r.data.ResultQueryInfo.UserMessages}, {root: true});
          reject({status: r.status, text: r.data.ResultQueryInfo.UserMessages});
        }
        let items = [];
        r.data.Items.forEach(item => {
          item.value = item.Id || item.ID;
          item.label = item.Name;
          items.push(item)
        });
        context.state.load = false;
        resolve(items)
      }).catch(e => {
        context.dispatch('error', e, {root: true});
        reject(e)
      });
    })
  },
  re_list(context) {
    context.state.error = false;
    context.state.errorText = '';
    context.state.load = false;
    context.state.dataUploaded = false;
    context.dispatch('get_list');
  },
};

const getters = {
  list: (state, getters, rootState, rootGetters) => (direction, cType, bonus) => {
    let type = cType === 7 ? (rootState.user.isSubAgent ? 3 : 1) : cType;
    return getters.sort_list.filter(i => {
      if (!bonus && i.PaymentTypeCategoryId === 2) return false;
      let a = true;
      if (direction === 0 || direction > 0) {
        a = i.InOut === direction;
      }
      if (!a) return false;
      if (type || type === 0) {
        let cTypes = rootGetters['dictionary/contragentType/list'](i.value);
        a = !!cTypes.filter(i => {
          return i.value === type;
        })[0];
      }


      return a;
    })
  },
  getById: (state, getters) => id => {
    if (!state.items.length) return null;
    return state.items.filter(i => {
      return i.value === id;
    })[0] || {};
  },
  bonuses: (state, getters) => {
    if (!state.items.length) return [];
    return state.items.filter(i => {
      return i.PaymentTypeCategoryId === 2;
    }) || [];
  },
  getName: (state, getters) => id => {
    if (!state.items.length) return null;
    let a = state.items.filter(i => {
      return i.value === id;
    })[0];
    return a ? a.Name : '';
  },
  sort_list: (state) => {
    return state.items.sort((a, b) => {
      return a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1;
    });
  },
};


export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
